

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { CLIENT_SETUP_VALIDATION_LEVELS } from "@/data/models/ClientSetup";
import { ClientSetupDraft, FirstUserForm, MIN_PASSWORD_LENGTH, firstUserErrors } from "@/utils/ClientSetupDraft";

@Component
export default class SetupUsersStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  /** Set by the page when IRES Cloud refused ANLEGEN for one of these. */
  @Prop({ default: false }) nicknameTaken!: boolean;
  @Prop({ default: false }) staffNumberTaken!: boolean;
  @Prop({ default: false }) userEmailTaken!: boolean;

  showPassword = false;
  touched: Record<string, boolean> = {};

  get roleLabel(): string {
    return this.$t("users.role.sysAdmin").toString();
  }

  get validationLevelItems() {
    return CLIENT_SETUP_VALIDATION_LEVELS.map((value) => ({
      value,
      label: this.$t(`users.validationLevel.${value.toLowerCase()}`).toString(),
    }));
  }

  get errors(): Array<keyof FirstUserForm> {
    return firstUserErrors(this.draft.firstUser);
  }

  errorFor(field: keyof FirstUserForm): string[] {
    if (!this.errors.includes(field) || !this.touched[field]) {
      return [];
    }
    switch (field) {
      case "emailAddress":
        return [this.$t("common.invalidEmailAddress").toString()];
      case "temporaryPassword":
        return [this.$t("admin.clients.setup.passwordTooShort", [MIN_PASSWORD_LENGTH]).toString()];
      case "nickname":
        return this.draft.firstUser.nickname.trim() === ""
          ? [this.$t("admin.clients.masterData.fieldErrors.required").toString()]
          : [this.$t("admin.clients.setup.errors.NICKNAME_TAKEN").toString()];
      default:
        return [this.$t("admin.clients.masterData.fieldErrors.required").toString()];
    }
  }

  touch(field: string) {
    this.$set(this.touched, field, true);
  }
}
